import {
  SET_REGISTER_WITH_SESSION,
  SET_REGISTER_WITHOUT_SESSION,
  GET_REGISTER_WITHOUT_SESSION,
} from "./action";
const defaultState = {
  __htmlWithSession: "",
  __htmlWithoutSession: "",
  addNewtext: "",
};

export default function registerState(state = defaultState, action) {
  switch (action.type) {
    case GET_REGISTER_WITHOUT_SESSION:
      return state;
    case SET_REGISTER_WITHOUT_SESSION:
      return { ...state, ["__htmlWithoutSession"]: action.payload };
    case SET_REGISTER_WITH_SESSION:
      return { ...state, addNewtext: action.payload.text };
    default:
      return state;
  }
}
